// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-dashboard-current-status--layout {\n  margin-bottom: 10px; }\n  .student-dashboard-current-status--layout .student-dashboard-current-status--bars-container {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 8px; }\n    .student-dashboard-current-status--layout .student-dashboard-current-status--bars-container .container-progress {\n      margin-bottom: 5px; }\n", ""]);
// Exports
module.exports = exports;
